module.exports = __webpack_public_path__ + "img/balance-icon.6d9eb1fd.png";